export const radiuses = {
  r0: '0px',
  r1: '3px',
  r2: '4px',
  r3: '8px',
  r4: '12px'
};
